(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', 'prop-types'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes);
    global.MenuAnimation = mod.exports;
  }
})(this, function (exports, _react, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Animate sub menu flyouts.
   * @param {boolean} animationState should the animation fire?
   * @param {number} duration how long should the animation last?
   * @param {object} styles styles to apply to the component.
   * @param {boolean} isMobile is the component rendering on the mobile view?
   * @param {node} children the component's children to render.
   * @return A jsx menu component.
   */
  var MenuAnimation = function MenuAnimation(_ref) {
    var animationState = _ref.animationState,
        duration = _ref.duration,
        styles = _ref.styles,
        isMobile = _ref.isMobile,
        children = _ref.children;

    function randomString(length) {
      var text = '';
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    }
    var animationClass = animationState ? 'show' : 'dont-show';
    var uniqueId = randomString(5);
    if (isMobile) {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('style', {
          dangerouslySetInnerHTML: {
            __html: '\n              .sub-menu-mobile-' + uniqueId + ' {\n                visibility: hidden;\n                max-height: 0;\n                opacity: 0;\n              }\n\n              @keyframes show-mobile {\n                0% {\n                  display: block;\n                }\n                100% {\n                  max-height: 500px;\n                  visibility: visible;\n                  opacity: 1;\n                }\n              }\n\n              .sub-menu-mobile-' + uniqueId + '.show {\n                animation: show-mobile ' + duration + 'ms 1 ease-in-out forwards;\n              }\n          '
          }
        }),
        _react2.default.createElement(
          'div',
          {
            className: 'sub-menu-mobile-' + uniqueId + ' ' + animationClass,
            style: styles
          },
          children
        )
      );
    }

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement('style', {
        dangerouslySetInnerHTML: {
          __html: '\n          .sub-menu-desktop-' + uniqueId + ' {\n            visibility: hidden;\n            width: 0;\n            opacity: 0;\n            left: 100%;\n            overflow: hidden;\n            white-space: nowrap;\n          }\n          @keyframes show-desktop {\n            50% {\n              width: 100%;\n            }\n            100% {\n              width: 100%;\n              visibility: visible;\n              opacity: 1;\n            }\n          }\n          .sub-menu-desktop-' + uniqueId + '.show {\n            animation: show-desktop ' + duration + 'ms linear forwards;\n          }\n        '
        }
      }),
      _react2.default.createElement(
        'div',
        {
          className: 'sub-menu-desktop-' + uniqueId + ' ' + animationClass + '  sub-menu-wrapper',
          style: styles
        },
        children
      )
    );
  };

  MenuAnimation.propTypes = {
    animationState: _propTypes2.default.bool,
    duration: _propTypes2.default.number,
    mobileStyles: _propTypes2.default.object,
    styles: _propTypes2.default.object,
    isMobile: _propTypes2.default.bool,
    children: _propTypes2.default.node
  };

  exports.default = MenuAnimation;
});